module.exports = __webpack_public_path__ + "static/media/rv.87a918de.svg";